export default {
    "title": "Facturas / {{client}}",
    "description": "Listado de facturas con descarga en formato PDF",
    "filters": {
        "invoiceNumber": "Número de factura"
    },
    "invoicesHeader": "<0>{{count}}</0> facturas por importe total de <0>{{total}}</0> €",
    "invoicesTableColumns": {
        "date": "Fecha de Factura",
        "document_id": "Número de Factura",
        "base": "Base Imponible",
        "vat": "Impuestos",
        "total": "Importe Total"
    },
    "nameCollection": "facturas"
}